import { render, staticRenderFns } from "./dMessage.vue?vue&type=template&id=54f20436&scoped=true&"
import script from "./dMessage.vue?vue&type=script&lang=js&"
export * from "./dMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f20436",
  null
  
)

export default component.exports